import { RefObject } from 'react';
import { CommonFormField } from '../../../../components/Form/CommonFormField';
import {
  NumericAttributeInput,
  NumericAttributeInputProps,
} from '../../../../components/HeadlessComponents/NumericAttributeInput';

export type NumericAttributeFieldProps = Omit<NumericAttributeInputProps, 'error'> & {
  required?: boolean;
  error?: string;
  fieldRef?: RefObject<HTMLDivElement>;
};

/**
 * Layer B numeric field wrapper. See `TextAttributeField` for shape rationale.
 */
export const NumericAttributeField = ({
  attribute,
  required,
  error,
  fieldRef,
  ...inputProps
}: NumericAttributeFieldProps) => (
  <CommonFormField label={attribute.displayName} required={required} error={error} ref={fieldRef}>
    <NumericAttributeInput attribute={attribute} {...inputProps} error={!!error} />
  </CommonFormField>
);
